import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ReportActionsService {
  private url = `${environment.AccountingAPI}api/v1/Report/`;

  constructor(private http: HttpClient) {}
  // /**
  //  * It returns an Observable of a string with link to the report
  //  * @param {number} id - number - the id of the employee
  //  * @returns Observable<string>
  //  */
  // generateSalaryReportsById(id: number): Observable<Blob> {
  //   return this.http.get<Blob>(`${this.url}api/v1/Salary/Report/local/download/${id}`, {responseType: 'blob' as 'json'});
  // }

  generateAllReports(): Observable<Blob> {
    return this.http.post<Blob>(
      `${this.url}generateForAll`,
      {},
      {responseType: 'blob' as 'json'}
    );
  }

  sendReportsToAll(): Observable<void> {
    return this.http.get<void>(`${this.url}sendAll`);
  }

  generateReportById(employeeId: number): Observable<boolean> {
    return this.http
      .post<void>(
        `${this.url}${employeeId}`,
        {},
        {responseType: 'text' as 'json'}
      )
      .pipe(map(() => true));
  }

  downloadEmployeeReport(employeeId: number): Observable<Blob> {
    return this.http.get<Blob>(`${this.url}download/${employeeId}`, {
      responseType: 'blob' as 'json',
    });
  }

  getEmployeeReportName(employeeId: number): Observable<string> {
    return this.http.get(`${this.url}fileName/${employeeId}`, {
      responseType: 'text',
    });
  }

  sendReportToEmployee(employeeId: number) {
    return this.http.get(`${this.url}send/${employeeId}`);
  }
}
